/* eslint-disable unicorn/empty-brace-spaces */
/* eslint-disable no-empty */
/* eslint-disable unicorn/prefer-optional-catch-binding */
import { IProduct, IProductVariations } from '../../models';
import React, { useState, useEffect, useRef } from 'react';
import { Label, Radio, RadioGroup } from '@headlessui/react';
import { classNames } from '../../helpers/classes';
import usePrice from '../../hooks/usePrice';
import BlueButtonBig from '../BlueButtonBig';
import useQueryParams from '../../hooks/useQueryParams';
import { addProduct } from '../../fetchers/cart';
import { getLangCountry } from '../../helpers/languages';
import Spinner from '../Spinner';
import SizeChartModal from '../SizeChartModal';
import StickyPopup from './StickyPopup';
import { SET_SESSION_DATA } from '../../context/types';
import { useTranslation } from 'react-i18next';
import { useAlert } from '../../context/AlertProvider';
import { useSelector, useStore } from 'react-redux';
import { IGlobalState } from '../../context/reducer';
import TrackVisibility from 'react-on-screen';
import { getToken } from '../../helpers/auth';
import ProductMoreInfo from './ProductMoreInfo';
import ProductLightbox from './ProductLightbox';
import ProductBoxImage from './ProductBoxImage';
import ProductBreadcrumbs from './ProductBreadcrumbs';
import ProductTitleDescription from './ProductTitleDescription';
import { useRouter } from 'next/router';
import { sortSizes } from '../../helpers/products';
import * as pixelFB from '../../helpers/pixelEvents';
import { getCurrencyName, getCurrencySymbol } from '../../helpers/prices';
import { fetchColors } from '../../fetchers/mapping';
import { fetchShippingCountriesList } from '../../fetchers/shipping';
import StockNotificationForm from './StockNotificationForm';
import ImgPromoBanner from '../../public/img/promo-banner-img.jpg';
import dynamic from 'next/dynamic';
const WidgetScalapay = dynamic(() => import('../WidgetScalapay'), {
  ssr: false
});

export const SIZES_ORDER = {
  XXS: 0,
  XS: 1,
  S: 2,
  M: 3,
  L: 4,
  XL: 5,
  XXL: 6,
  XXXL: 7
} as { [key: string]: number };

export interface PopupSection {
  ContentComponent: React.FC;
}

export default function ProductOverviews({
  product,
  shippmentAndReturnInfoText,
  loadingProduct
}: {
  product: IProduct;
  shippmentAndReturnInfoText: string;
  loadingProduct: boolean;
}) {
  const router = useRouter();
  const [formatPrice] = usePrice();
  const token = getToken();
  const [query] = useQueryParams();
  const { session } = useSelector<IGlobalState, IGlobalState>(
    state => state || {}
  );
  const colorsCodeToLabel = fetchColors();
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [sectionPopup, setSectionPopup] = useState<PopupSection>();
  const [imageGallery, setImageGallery] = useState('');
  const alert = useAlert();
  const store = useStore();
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);

  const { colors = [], variations = [], video = '', extreme } = product || {};

  const [availableSizes, setAvailableSizes] = useState<Array<string>>([]);
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [sizeError, setSizeError] = useState(false);
  const { lang, country } = getLangCountry(query);
  const countries = fetchShippingCountriesList({ lang });
  const currCurrency = getCurrencySymbol(countries, country);
  const currencyCode = getCurrencyName(countries, country);

  const inStock = (sku: string) => {
    const variation = variations.find(variation => variation.sku === sku);

    return (
      Number(variation?.stock?.in_stock) === 1 &&
      Number(variation?.stock?.stock_quantity) > 0
    );
  };

  const getColorLabel = (color_code?: string) => {
    if (!color_code) return '';
    const { color = '' } = colorsCodeToLabel[color_code] || {};
    return color;
  };

  useEffect(() => {
    setAvailableSizes([]);
    setSelectedColor('');
    setSelectedSize('');
  }, [router.asPath]);

  useEffect(() => {
    if (product.default_color) {
      setSelectedColor(product.default_color);
    }
  }, [product.default_color]);
  useEffect(() => {
    //PIXEL EVENT ViewContent
    if (selectedSize) {
      setSizeError(false);

      // pixelFB.event({
      //   eventName: 'ViewContent',
      //   content_ids: [product.selling_code],
      //   content_name: product.productName,
      //   value: getSelectedVariation()?.price.price,
      //   currency: currCurrency
      // });
    }
  }, [selectedSize]);

  useEffect(() => {
    const availableSizes = variations
      .filter(
        ({ attribute_color, sku }: IProductVariations) =>
          attribute_color === selectedColor && inStock(sku)
      )
      .map(({ attribute_size }: IProductVariations) => attribute_size);

    if (!selectedColor) {
      setSelectedColor(product.default_color);
    }

    setAvailableSizes(availableSizes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colors, selectedColor]);

  const getSelectedColor = () => {
    return (
      colors.find(color => color.color_code === selectedColor) || { images: [] }
    );
  };

  const getFirstVariation = (): IProductVariations | undefined => {
    return variations.find(
      ({ attribute_color }: IProductVariations) =>
        attribute_color === selectedColor
    );
  };

  const getSelectedVariation = (): IProductVariations | undefined => {
    return variations.find(
      ({ attribute_color, attribute_size }: IProductVariations) =>
        attribute_color === selectedColor && attribute_size === selectedSize
    );
  };

  const onAddToCart = () => {
    if (!selectedSize) {
      setSizeError(true);
      return;
    }

    const sku = getSelectedVariation()?.sku;
    const addToCart = async () => {
      try {
        setLoading(true);

        const { cart, coupons } = await addProduct({
          ...getLangCountry(query),
          token,
          sku: sku!,
          quantity: 1
        });

        store.dispatch({
          type: SET_SESSION_DATA,
          payload: { ...session, cart, coupons }
        });
        // Simulo il click sul pulsante per aprire il carrello
        document.querySelector<HTMLButtonElement>('#menu-cart')?.click();
        alert.show(t('PRODUCT_ADDED_TO_CART'));

        //PIXEL EVENT AddToCart
        // pixelFB.event({
        //   eventName: 'AddToCart',
        //   content_ids: [product.selling_code],
        //   currency: currCurrency
        // });

        // GA Event
        if (variation) {
          const { breadcrumbs, productName, product_type, selling_code } =
            product;
          const category = breadcrumbs[breadcrumbs.length - 1] || {};
          const { color = '' } =
            colorsCodeToLabel[variation.attribute_color] || {};

          if (window.dataLayer) {
            const { lang, country } = getLangCountry(router.query);

            const countries = fetchShippingCountriesList({ lang });
            const currentCountry = countries.find(c => {
              return c['country-code']?.toLowerCase() === country.toLowerCase();
            });
            let value =
              variation?.price?.sale_price || variation?.price?.price || 0;
            let discount = 0;
            if (
              variation?.price?.sale_price &&
              variation?.price?.price &&
              Number.parseFloat(variation.price?.price) > 0 &&
              Number.parseFloat(variation.price?.sale_price) > 0
            ) {
              discount =
                Number.parseFloat(variation.price?.price) -
                Number.parseFloat(variation.price?.sale_price);
            }
            const category = breadcrumbs[breadcrumbs.length - 1] || {};

            window.dataLayer?.push({ ecommerce: null });
            window.dataLayer?.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: currentCountry?.currency || 'EUR',
                value,
                items: [
                  {
                    item_id: product_type + '-' + selling_code,
                    item_name: productName,
                    discount,
                    index: 0,
                    item_brand: 'Jeep',
                    item_category: category.slug,
                    item_list_id: 'single_product_page',
                    item_list_name: 'Single product page',
                    item_variant: variation!.sku,
                    price: value,
                    quantity: 1
                  }
                ]
              }
            });
          }
        }
      } catch (error) {
        alert.error(t('GENERIC_ERROR'));
      } finally {
        setLoading(false);
      }
    };
    if (sku) addToCart();
  };

  const getGallery = (): string[] => {
    const gallery = [...getSelectedColor().images];
    if (video) {
      gallery.splice(2, 0, video);
    }
    return gallery;
  };

  const onVideoClick = () => {
    if (videoRef.current?.paused) {
      videoRef.current.play();
      return;
    }

    videoRef.current?.pause();
  };

  const getProductCode = () => {
    return getSelectedVariation()?.sku || getFirstVariation()?.sku;
  };

  const getPrice = () => {
    if (getSelectedVariation()) {
      return getSelectedVariation()?.price;
    }

    const [variation] = variations
      .filter(
        ({ attribute_color }: IProductVariations) =>
          attribute_color === selectedColor
      )
      .sort((a, b) => {
        const price1 = (a && a.price && a.price.price) || 0;
        const price2 = (b && b.price && b.price.price) || 0;
        if (price1 < price2) return -1;
        if (price1 > price2) return 1;
        return 0;
      });

    return variation?.price;
  };

  const getOriginalPrice = () => {
    return getPrice()?.price;
  };

  const getSalePrice = () => {
    return getPrice()?.sale_price || 0;
  };

  const getLabelFromAttribute = (attribute_size: string) => {
    const variation = variations.find(
      variation => variation.attribute_size === attribute_size
    );

    return variation?.label_size;
  };

  const ORIGINAL_PRICE = getOriginalPrice();
  const SALE_PRICE = getSalePrice();
  const variation = getSelectedVariation();

  useEffect(() => {
    const variation = variations[0];

    const { breadcrumbs, productName, product_type, selling_code } = product;
    const category = breadcrumbs[breadcrumbs.length - 1] || {};
    let discount = 0;
    if (
      variation?.price?.sale_price &&
      variation?.price?.price &&
      Number.parseFloat(variation.price?.price) > 0 &&
      Number.parseFloat(variation.price?.sale_price) > 0
    ) {
      discount =
        Number.parseFloat(variation.price?.price) -
        Number.parseFloat(variation.price?.sale_price);
    }
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: 'view_item',
      ecommerce: {
        currency: currencyCode,
        value: variation?.price?.sale_price || variation?.price?.price || 0,
        items: [
          {
            item_id: product_type + '-' + selling_code,
            item_name: productName,
            discount: discount,
            index: 0,
            item_brand: 'Jeep',
            item_category: category.slug,
            item_list_id: 'single_product_page',
            item_list_name: 'Single product page',
            item_variant: variation?.attribute_color,
            price: variation?.price?.sale_price || variation?.price?.price || 0,
            quantity: 1
          }
        ]
      }
    });
  }, [product.selling_code]);

  return (
    <div className="bg-grey-custom">
      {imageGallery && (
        <ProductLightbox
          close={() => setImageGallery('')}
          image={imageGallery}
          images={getSelectedColor().images}
        />
      )}
      <div className="pt-6 pb-16 sm:pb-120">
        <StickyPopup
          product={product}
          price={formatPrice(SALE_PRICE ? SALE_PRICE : ORIGINAL_PRICE)}
          image={getSelectedColor().images[0]}
          show={showPopup || !!sectionPopup}
          section={sectionPopup}
          setSection={setSectionPopup}
        />
        <div className="max-w-2xl px-4 mx-auto mt-8 sm:px-6 lg:max-w-full lg:px-12">
          <div className="lg:grid lg:grid-cols-12 lg:auto-rows-min lg:gap-x-8">
            {/* Name and product details */}
            <div className="lg:col-start-9 lg:col-span-4">
              {/* TODO: @andrea - Rimuovere */}
              {/* <div className="mb-4 overflow-hidden rounded-lg bg-primary md:flex md:space-y-0">
                <div className="flex flex-col justify-center flex-1 px-4 py-4 lg:py-6">
                  <div>
                    <div className="inline-flex px-2 py-1 mb-3 text-xs font-bold uppercase bg-black rounded-sm text-primary">
                      {t('PROMO_BANNER.LABEL')}
                    </div>
                  </div>
                  <p className="mb-1 font-sans text-2xl font-bold text-center text-black lg:text-left">
                    {t('PROMO_BANNER.TITLE')}
                  </p>
                </div>

                <div className="flex items-center justify-center lg:pl-24">
                  <img
                    src={ImgPromoBanner.src}
                    alt="Banner product"
                    className="w-40 h-auto"
                  />
                </div>
              </div> */}

              <ProductBreadcrumbs product={product} />
              <p className="mb-2 text-sm opacity-60">{getProductCode()}</p>
              <ProductTitleDescription
                gallery={getGallery()}
                product={product}
              />

              <p className="pt-6">
                {!loadingProduct && (
                  <span className="pr-2 font-bold text-primary">
                    {SALE_PRICE ? (
                      <>
                        <span className="text-gray-400 line-through">
                          {formatPrice(ORIGINAL_PRICE)}
                        </span>
                        <span className="font-bold">
                          {' '}
                          {formatPrice(SALE_PRICE)}
                        </span>
                      </>
                    ) : (
                      formatPrice(ORIGINAL_PRICE)
                    )}
                  </span>
                )}
                <span className="pl-2 font-normal text-gray-400 border-l border-gray-200">
                  {getColorLabel(selectedColor)}
                </span>
              </p>

              <WidgetScalapay
                lang={lang}
                amount={
                  SALE_PRICE
                    ? Number.parseFloat(SALE_PRICE)
                    : Number.parseFloat(ORIGINAL_PRICE ? ORIGINAL_PRICE : '0')
                }
              />
            </div>
            {/* Image gallery */}
            <div className="hidden mt-6 lg:mt-0 lg:col-start-1 lg:col-span-8 lg:row-start-1 lg:row-span-3 lg:block">
              <h2 className="sr-only">Images</h2>

              <div
                className={`grid grid-cols-1 lg:grid-cols-2 lg:grid-rows-${Math.floor(
                  getGallery().length / 2
                )} lg:gap-4`}
              >
                {getGallery().map((item: string, i: number) => {
                  if (video && item === video) {
                    return (
                      <video
                        key={i}
                        ref={videoRef}
                        autoPlay
                        muted
                        loop
                        onClick={onVideoClick}
                        className="rounded-md"
                        playsInline
                      >
                        <source type="video/mp4" src={item}></source>
                      </video>
                    );
                  }
                  return (
                    <img
                      key={i}
                      src={item}
                      alt={product.productName}
                      onClick={() => setImageGallery(item)}
                      className="rounded-md cursor-pointer"
                    />
                  );
                })}
              </div>
            </div>

            <div className="mt-6 lg:col-span-4" id="product-add-to-cart">
              <form>
                {/* Color picker */}
                <div>
                  <h2 className="text-sm font-bold text-gray-900 uppercase">
                    {t('FILTERS.color')}
                  </h2>
                  <div className="flex mt-2">
                    {colors.map((color, i) => (
                      <div
                        key={`color-${i}`}
                        className={classNames(
                          selectedColor === color.color_code
                            ? 'border-primary'
                            : 'border-transparent',
                          'bg-white border rounded-md m-1 cursor-pointer overflow-hidden'
                        )}
                        aria-hidden="true"
                      >
                        <img
                          src={color.images[0]}
                          alt={getColorLabel(color.color_code)}
                          className="w-16"
                          onClick={() => setSelectedColor(color.color_code)}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Size picker */}
                <div className="mt-3">
                  <div className="flex items-center justify-between">
                    <h2 className="text-sm font-bold text-gray-900 uppercase">
                      {t('FILTERS.size')}
                    </h2>
                    <SizeChartModal product={product} />
                  </div>

                  <RadioGroup
                    value={selectedSize}
                    onChange={setSelectedSize}
                    className="mt-2"
                  >
                    <Label className="sr-only">{t('CHOOSE_SIZE')}</Label>
                    <div className="grid grid-cols-4 gap-2 sm:grid-cols-5 xl:grid-cols-8">
                      {variations
                        .filter(
                          ({ attribute_color }) =>
                            attribute_color === selectedColor
                        )
                        .sort((a, b) =>
                          sortSizes(a.attribute_size, b.attribute_size)
                        )
                        .map(({ sku, attribute_size }) => {
                          const available =
                            availableSizes.includes(attribute_size);
                          const label_size =
                            getLabelFromAttribute(attribute_size);

                          return (
                            <Radio
                              key={sku}
                              value={attribute_size}
                              onClick={() =>
                                attribute_size &&
                                available &&
                                setSelectedSize(attribute_size)
                              }
                              className={({ checked }) =>
                                classNames(
                                  attribute_size
                                    ? 'cursor-pointer focus:outline-none'
                                    : 'opacity-100',
                                  available
                                    ? 'cursor-pointer focus:outline-none'
                                    : 'opacity-100',
                                  checked ? 'border-primary' : 'border-none',
                                  'bg-white border rounded-md py-3 px-3 flex items-center justify-center text-sm font-bold uppercase sm:flex-1'
                                )
                              }
                            >
                              <Label as="p">{label_size}</Label>
                            </Radio>
                          );
                        })}
                    </div>
                  </RadioGroup>
                </div>

                {sizeError && (
                  <div className="p-3 mt-3 text-red-500 border border-red-500 rounded-md bg-red-50">
                    {t('SIZE_NOT_SELECTED')}
                  </div>
                )}
                {/* <TrackVisibility>
                  {({ isVisible }) => {
                    if (isVisible === showPopup) {
                      setShowPopup(!isVisible);
                    }
                    return (
                      <div className="w-full mt-8">
                        {loading ? (
                          <Spinner />
                        ) : (
                          <BlueButtonBig
                            disabled={!inStock(variation?.sku!)}
                            type="button"
                            extreme={extreme}
                            text={
                              !variation
                                ? t('SELECT_PRODUCT_SIZE')
                                : inStock(variation?.sku!)
                                ? t('ADD_TO_CART')
                                : t('PRODUCT_NOT_AVAILABLE')
                            }
                            onClick={onAddToCart}
                          />
                        )}
                      </div>
                    );
                  }}
                </TrackVisibility> */}
              </form>

              {variation?.sku !== undefined && !inStock(variation.sku) && (
                <StockNotificationForm
                  sku={variation.sku}
                  size={selectedSize}
                />
              )}

              {/* <ProductBoxImage icons={product.icons} /> */}

              <ProductMoreInfo
                product={product}
                setSection={setSectionPopup}
                variant={getSelectedVariation() || getFirstVariation()}
                shippmentAndReturnInfoText={shippmentAndReturnInfoText}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
